__turbopack_context__.v({
  "actions": "BDirCW_actions",
  "groupLink": "BDirCW_groupLink",
  "groupLinkMobile": "BDirCW_groupLinkMobile",
  "groupLinkMobileContainer": "BDirCW_groupLinkMobileContainer",
  "groupLinkMobileTitle": "BDirCW_groupLinkMobileTitle",
  "root": "BDirCW_root",
  "tabsLabel": "BDirCW_tabsLabel",
  "tabsList": "BDirCW_tabsList",
  "tabsRoot": "BDirCW_tabsRoot",
  "triggerButton": "BDirCW_triggerButton",
});
